module.exports = __webpack_public_path__ + "img/zhenglogo.b0dc306b.png";